export default "__VITE_ASSET__I5STS1Q0__"